import { data } from '../../svg/Order/data';
import { makeIcon } from '../makeIcon';

export const Order = makeIcon(data, 'order', 'Order');

export default Order;
